<template>
    <div>
        <v-card>
            <v-card-title>Powiadomienia</v-card-title>
            <v-card-text>
                <my-form ref="form">
                    <p class="grey--text">Powiadomienia email:</p>
                    <v-switch label="Wysyłaj do mnie powiadomienie email przy złożonym zamówieniu" v-model="item.sendOrderEmails" :true-value="1" :false-value="0"></v-switch>
                    <v-text-field :rules="[rules.required]" v-if="item.sendOrderEmails" label="Adres email na który mają przychodzić powiadomienia" v-model="item.orderEmail"></v-text-field>

                    <v-divider></v-divider>
                    <p class="grey--text mt-4">Powiadomienia w panelu administratora:</p>
                    <v-switch label="Powiadom mnie gdy ceny produktu u dostawcy się zmieniają" v-model="item.productNotifications" :true-value="1" :false-value="0"></v-switch>
                    <v-switch label="Powiadom mnie gdy ktoś dokona płatności" v-model="item.newPayments" :true-value="1" :false-value="0"></v-switch>
                </my-form>
            </v-card-text>
            <v-card-actions>
                <v-btn color="green" depressed @click="save()">Zapisz</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
    import {storeBread, editBread, getBreads} from "../../api/bread";

    export default {
        data:() => {return {
            id: null,
            rules:{
                required: v => !!v || 'Ten element jest wymagany'
            },
            item:{},
            errors:[]
        }},
        computed:{
            user(){return this.$store.getters.user}
        },
        mounted() {
            this.getItem();
        },
        methods:{
            getItem(){
                getBreads('Setting', {model: 'user',model_name:'Setting', type:'notifications', foreign_key: this.user.id}).then(res => {
                    if(res.data.length > 0){
                        this.item = JSON.parse(res.data[0].content);
                        this.id = res.data[0].id;
                    }
                })
            },
            save(){
                if(this.$refs.form.my_validate()){
                    var func = null;
                    var data = {
                        model_name: 'Setting',
                        type: 'notifications',
                        model: 'user',
                        foreign_key: this.user.id
                    }
                    data.content = JSON.stringify(this.item);
                    if(!this.id){
                        func = storeBread('Setting', data);
                    }else{
                        func = editBread('Setting', data, this.id);
                    }
                    func.then(res => {
                        if(this.item.id){
                            this.$store.commit('app/ADD_MESSAGE', {text: 'Edytowano poprawnie', type:'success'});
                        }else{
                            this.$store.commit('app/ADD_MESSAGE', {text: 'Zapisano poprawnie', type:'success'});
                        }
                        this.id = res.id;
                    }).catch(e => {
                        this.$store.commit('app/ADD_MESSAGE', {text: 'Błąd w zapisywaniu', type:'error'});
                        this.errors = e.response.data.errors;
                    })
                }
            }
        }
    }
</script>
